import { createAsyncAction } from 'typesafe-actions';
import { ForgotPasswordDto } from './forgotPassword.dtos';

export const forgotPasswordActions = createAsyncAction(
  'FORGOT_PASSWORD_REQUEST',
  'FORGOT_PASSWORD_SUCCESS',
  'FORGOT_PASSWORD_ERROR',
)<ForgotPasswordDto, boolean, string>();